import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { SnowflakeAccesses } from "./accesses.ts";
import { SnowflakeComponents } from "./components.ts";

const SnowflakeFilters = {
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;

export type SnowflakeFilters = typeof SnowflakeFilters;

export const SnowflakeRegistration = Registration({
  accesses: SnowflakeAccesses,
  category: "resource",
  components: SnowflakeComponents,
  docs: { install: "snowflake" },
  filters: SnowflakeFilters,
  itemKind: "account",
  label: "Snowflake",
  logoUrl: "https://avatars.githubusercontent.com/u/6453780?s=200&v=4",
  maturity: "ga",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("snowflake", SnowflakeRegistration);
